'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { usePostHogClient } from '@/components/PostHogProvider';

export default function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  // Reactive: null until PostHog loads on idle, then flips to the client and
  // re-runs this effect to fire the first pageview. Same reactivity the old
  // `usePostHog()` provided, but without the tree-remounting provider swap.
  const posthog = usePostHogClient();

  useEffect(() => {
    if (pathname && posthog?.capture) {
      let url = window.origin + pathname;
      if (searchParams && searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }

      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams, posthog]);

  return null;
}

